import type { SurfaceProps } from './types';
import { surfaceFilled } from './types';

/** Numbered list surface (acceptance criteria · or «found holes» with a requirement shown). */
export function AcList({ spec, value, disabled, onChange }: SurfaceProps) {
  const items = Array.isArray(value?.items) ? (value!.items as string[]) : ['', '', ''];
  const noun = spec.config?.itemLabel ?? 'критерий';
  const emit = (next: string[]) => onChange({ items: next }, surfaceFilled(spec, { items: next }));

  return (
    <div className="surf surf-aclist" data-testid="surf-aclist">
      {spec.config?.requirement && (
        <div className="surf-req"><span className="lab">Дано</span>{spec.config.requirement}</div>
      )}
      <div className="surf-tag">{noun === 'дыра' ? 'Найденные дыры' : 'Критерии приёмки'}</div>
      {items.map((row, i) => (
        <div className="ac-row" key={i}>
          <span className="n">{i + 1}</span>
          <input value={row} disabled={disabled} placeholder={`${noun}…`}
            onChange={(e) => { const n = items.slice(); n[i] = e.target.value; emit(n); }} />
          {items.length > 1 && !disabled && (
            <button type="button" className="rm" aria-label="убрать"
              onClick={() => emit(items.filter((_, j) => j !== i))}>×</button>
          )}
        </div>
      ))}
      {!disabled && (
        <button type="button" className="surf-add" onClick={() => emit([...items, ''])}>
          + ещё {noun}
        </button>
      )}
    </div>
  );
}
